/* Skapad av Claude Code — paketsidans produktkort v2 + produktpanelen (snippets/svd-paket-kort.liquid).
   1. Panelen: knappen "Läs mer om produkten" öppnar en <dialog> med produktens mall (<template>).
      Bläddra med pilarna/piltangenterna, stäng med kryss, Esc eller klick utanför. Utan skript eller
      utan <dialog>-stöd är knappen en vanlig länk till produktsidan.
   2. Egna rader: kort med data-pkk-hamta (tillskott, flaska, tassalva …) hämtar produktsidan och byter
      reservraden "Om produkten" mot sidans egna rader (temats collapsible-row, godis- och leksaksrader).
      Hämtas en gång per produkt, när korten närmar sig skärmen eller panelen öppnas; tidsgräns 10 s.
      Misslyckas något ligger serverns rader kvar.
   3. Mobil: prickarna följer svepet. Raderna i "Det här ingår" sveper fram rätt kort. */
(function () {
  'use strict';

  var RADER = 'collapsible-row.product__accordion details, .svd-godis-acc details, .svd-lk-acc details';
  var HOPPA = /kunderna|recension|omdöme/i;
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var cache = {};

  function hamta(url) {
    if (cache[url]) return cache[url];
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 10000) : 0;
    cache[url] = fetch(url, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        clearTimeout(timer);
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('link[rel="stylesheet"][href*="svd-pdp-intro"]').forEach(function (l) {
          var href = l.getAttribute('href');
          if (href && !document.querySelector('link[href="' + href + '"]')) document.head.appendChild(document.importNode(l, true));
        });
        var ut = [];
        doc.querySelectorAll(RADER).forEach(function (d) {
          if (d.parentElement && d.parentElement.closest('details')) return;
          var sum = d.querySelector('summary');
          if (!sum) return;
          var s = sum.cloneNode(true);
          s.querySelectorAll('svg').forEach(function (x) { x.remove(); });
          var titel = s.textContent.replace(/\s+/g, ' ').trim();
          if (!titel || HOPPA.test(titel)) return;
          var body = d.querySelector('.collapsible__content, .svd-godis-acc-body, .svd-lk-acc__body');
          var html2;
          if (body) {
            html2 = body.innerHTML;
          } else {
            var c = d.cloneNode(true);
            var cs = c.querySelector('summary');
            if (cs) cs.remove();
            html2 = c.innerHTML;
          }
          if (/jdgm-/.test(html2)) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html2;
          tmp.querySelectorAll('script, style, noscript').forEach(function (x) { x.remove(); });
          if (!tmp.textContent.trim() && !tmp.querySelector('img, table, ul, ol')) return;
          ut.push({ t: titel, h: tmp.innerHTML });
        });
        return ut;
      })
      .catch(function () { clearTimeout(timer); return null; });
    return cache[url];
  }

  function radHtml(rad, oppen) {
    var d = document.createElement('details');
    if (oppen) d.open = true;
    var s = document.createElement('summary');
    s.textContent = rad.t;
    s.insertAdjacentHTML('beforeend', CHEV);
    var b = document.createElement('div');
    b.className = 'svd-pkk-body svd-pk-rte';
    b.innerHTML = rad.h;
    d.appendChild(s);
    d.appendChild(b);
    return d;
  }

  function fyll(box, rader, antal, forstaOppen) {
    if (!box) return;
    var frag = document.createDocumentFragment();
    rader.slice(0, antal).forEach(function (r, i) { frag.appendChild(radHtml(r, forstaOppen && i === 0)); });
    box.innerHTML = '';
    box.appendChild(frag);
  }

  function init(root) {
    if (root.__pkk) return;
    root.__pkk = true;
    var kort = Array.prototype.slice.call(root.querySelectorAll('.svd-pkk-card'));
    if (!kort.length) return;
    var dlg = root.querySelector('[data-pkk-dlg]');
    var kanPanel = dlg && typeof dlg.showModal === 'function';
    var body = root.querySelector('[data-pkp-body]');
    var antalEl = root.querySelector('[data-pkp-antal]');
    var cur = -1, opener = null, stangTimer = 0;

    /* 2. Produktsidans egna rader */
    function uppdatera(k) {
      var url = k.getAttribute('data-pkk-hamta');
      if (!url) return Promise.resolve();
      return hamta(url).then(function (rader) {
        if (!rader || !rader.length || k.__pkkKlar) return;
        k.__pkkKlar = true;
        fyll(k.querySelector('.svd-pkk-b [data-pkk-rader]'), rader, 3, false);
        var tpl = k.querySelector('template[data-pkk-tpl]');
        if (tpl && tpl.content) fyll(tpl.content.querySelector('[data-pkk-rader]'), rader, rader.length, true);
        if (kort[cur] === k && dlg.open) visa(cur, true);
      });
    }
    function hamtaAlla() { kort.forEach(uppdatera); }
    if (kort.some(function (k) { return k.hasAttribute('data-pkk-hamta'); })) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en.some(function (e) { return e.isIntersecting; })) { io.disconnect(); hamtaAlla(); }
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      } else {
        hamtaAlla();
      }
    }

    /* 1. Panelen */
    function visa(i, behallScroll) {
      cur = (i + kort.length) % kort.length;
      var tpl = kort[cur].querySelector('template[data-pkk-tpl]');
      if (!tpl) return;
      var top = behallScroll ? body.scrollTop : 0;
      body.innerHTML = '';
      body.appendChild(document.importNode(tpl.content, true));
      body.scrollTop = top;
      if (antalEl) antalEl.textContent = 'Produkt ' + (cur + 1) + ' av ' + kort.length;
      body.querySelectorAll('[data-pkp-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          var main = body.querySelector('[data-pkp-main]');
          if (main) { main.src = b.getAttribute('data-pkp-thumb'); main.removeAttribute('srcset'); }
          body.querySelectorAll('[data-pkp-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      uppdatera(kort[cur]);
    }
    function oppna(i, fran) {
      clearTimeout(stangTimer);
      opener = fran || document.activeElement;
      visa(i, false);
      if (!dlg.open) dlg.showModal();
      document.documentElement.classList.add('svd-pkp-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-on'); }); });
    }
    function stang(direkt) {
      if (!dlg.open) return;
      dlg.classList.remove('is-on');
      clearTimeout(stangTimer);
      var klar = function () { if (dlg.open) dlg.close(); };
      var snabb = direkt || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (snabb) klar(); else stangTimer = setTimeout(klar, 340);
    }

    if (kanPanel) {
      root.querySelectorAll('[data-pkk-open]').forEach(function (a) {
        a.setAttribute('aria-haspopup', 'dialog');
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          var k = a.closest('.svd-pkk-card');
          var i = kort.indexOf(k);
          if (i < 0) return;
          e.preventDefault();
          oppna(i, a);
        });
      });
      dlg.addEventListener('close', function () {
        dlg.classList.remove('is-on');
        document.documentElement.classList.remove('svd-pkp-lock');
        if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (err) { opener.focus(); } }
      });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); stang(false); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) stang(false); });
      var x = dlg.querySelector('[data-pkp-close]');
      if (x) x.addEventListener('click', function () { stang(false); });
      var prev = dlg.querySelector('[data-pkp-prev]'), next = dlg.querySelector('[data-pkp-next]');
      if (prev) prev.addEventListener('click', function () { visa(cur - 1, false); });
      if (next) next.addEventListener('click', function () { visa(cur + 1, false); });
      dlg.addEventListener('keydown', function (e) {
        if (kort.length < 2) return;
        var t = e.target && e.target.tagName;
        if (t === 'INPUT' || t === 'TEXTAREA') return;
        if (e.key === 'ArrowRight') { e.preventDefault(); visa(cur + 1, false); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); visa(cur - 1, false); }
      });
      /* Köpknappen skickar paketets formulär som vanligt; panelen stängs så varukorgens notis syns. */
      var cta = dlg.querySelector('[data-pkp-cta]');
      if (cta) cta.addEventListener('click', function () { setTimeout(function () { stang(true); }, 0); });
    }

    /* 3. Mobil: prickar + "Det här ingår"-raderna */
    var grid = root.querySelector('[data-pkk-grid]');
    var prickar = root.querySelectorAll('[data-pkk-dots] i');
    if (grid && prickar.length) {
      var synka = function () {
        var forsta = kort[0];
        var steg = forsta.offsetWidth + (parseFloat(getComputedStyle(grid).columnGap) || 12);
        var n = Math.max(0, Math.min(prickar.length - 1, Math.round(grid.scrollLeft / steg)));
        for (var j = 0; j < prickar.length; j++) prickar[j].className = j === n ? 'is-on' : '';
      };
      grid.addEventListener('scroll', function () { window.requestAnimationFrame(synka); }, { passive: true });
    }
    document.querySelectorAll('.svd-pk-row[href^="#svd-pk-blk-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var mal = document.getElementById(a.getAttribute('href').slice(1));
        if (!mal || !root.contains(mal)) return;
        e.preventDefault();
        if (grid && grid.scrollWidth > grid.clientWidth + 1) {
          grid.scrollTo({ left: mal.offsetLeft - (parseFloat(getComputedStyle(grid).paddingLeft) || 0), behavior: 'smooth' });
        }
        var y = root.getBoundingClientRect().top + window.pageYOffset - 56;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  function start() { document.querySelectorAll('[data-pkk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
